/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { BEM } from "@adapptio/lib-components";

export enum RESIZER_POSITION {
	TOP = "top",
	TOP_LEFT = "top-left",
	TOP_RIGHT = "top-right",
	BOTTOM = "bottom",
	BOTTOM_LEFT = "bottom-left",
	BOTTOM_RIGHT = "bottom-right",
	LEFT = "left",
	RIGHT = "right"
}

export interface IFloatingPanelResizerPosition {
	top?: boolean;
	right?: boolean;
	bottom?: boolean;
	left?: boolean;
}

const positionEnumToObjectMap: Record<RESIZER_POSITION, IFloatingPanelResizerPosition> = {
	[RESIZER_POSITION.TOP]: { top: true },
	[RESIZER_POSITION.TOP_LEFT]: { top: true, left: true },
	[RESIZER_POSITION.TOP_RIGHT]: { top: true, right: true },
	[RESIZER_POSITION.BOTTOM]: { bottom: true },
	[RESIZER_POSITION.BOTTOM_LEFT]: { bottom: true, left: true },
	[RESIZER_POSITION.BOTTOM_RIGHT]: { bottom: true, right: true },
	[RESIZER_POSITION.LEFT]: { left: true },
	[RESIZER_POSITION.RIGHT]: { right: true }
};

export interface IFloatingPanelResizerProps {
	className?: string;
	position: RESIZER_POSITION;
}

export const FloatingPanelResizer: React.FC<IFloatingPanelResizerProps> = ({ className, position }) => {
	const baseClass = BEM("edt-floating-panel-resizer", null, {
		position
	});

	const dataPosition = useMemo(() => JSON.stringify(positionEnumToObjectMap[position]), [ position ]);

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()} data-position={dataPosition} />;
};
